import { Grid } from 'antd';

const { useBreakpoint } = Grid;

// Most of this code is taken directly from [Ant Designs useBreakpoint hook.](https://ant.design/components/grid#components-grid-demo-usebreakpoint)
// This function takes an argument ('mobile || 'tablet' || desktop)
// and returns whether or not that screensize is correct

export const checkScreenSize = () => {
  let size = '';
  const screens = useBreakpoint();
  Object.entries(screens)
    .filter(screen => !!screen[1])
    .map(screen => screen[0])
    .map((what) => {
      if (['xs'].includes(what)) size = 'mobile';
      else if (['sm', 'md'].includes(what)) size = 'tablet';
      else size = 'desktop';
    });
  return size;
};
